( () => {
    "use strict";
    function e(t) {
        return e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        e(t)
    }
    function t(t) {
        var n = function(t, n) {
            if ("object" != e(t) || !t)
                return t;
            var r = t[Symbol.toPrimitive];
            if (void 0 !== r) {
                var o = r.call(t, n || "default");
                if ("object" != e(o))
                    return o;
                throw new TypeError("@@toPrimitive must return a primitive value.")
            }
            return ("string" === n ? String : Number)(t)
        }(t, "string");
        return "symbol" == e(n) ? n : n + ""
    }
    function n(e, n) {
        for (var r = 0; r < n.length; r++) {
            var o = n[r];
            o.enumerable = o.enumerable || !1,
            o.configurable = !0,
            "value"in o && (o.writable = !0),
            Object.defineProperty(e, t(o.key), o)
        }
    }
    function r(t, n) {
        if (n && ("object" == e(n) || "function" == typeof n))
            return n;
        if (void 0 !== n)
            throw new TypeError("Derived constructors may only return object or undefined");
        return function(e) {
            if (void 0 === e)
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e
        }(t)
    }
    function o(e) {
        return o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        }
        ,
        o(e)
    }
    function c(e, t) {
        return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t,
            e
        }
        ,
        c(e, t)
    }
    function i() {
        try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}
            )))
        } catch (e) {}
        return (i = function() {
            return !!e
        }
        )()
    }
    function u(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return u = function(e) {
            if (null === e || !function(e) {
                try {
                    return -1 !== Function.toString.call(e).indexOf("[native code]")
                } catch (t) {
                    return "function" == typeof e
                }
            }(e))
                return e;
            if ("function" != typeof e)
                throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e))
                    return t.get(e);
                t.set(e, n)
            }
            function n() {
                return function(e, t, n) {
                    if (i())
                        return Reflect.construct.apply(null, arguments);
                    var r = [null];
                    r.push.apply(r, t);
                    var o = new (e.bind.apply(e, r));
                    return n && c(o, n.prototype),
                    o
                }(e, arguments, o(this).constructor)
            }
            return n.prototype = Object.create(e.prototype, {
                constructor: {
                    value: n,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }),
            c(n, e)
        }
        ,
        u(e)
    }
    function a() {
        try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}
            )))
        } catch (e) {}
        return (a = function() {
            return !!e
        }
        )()
    }
    var l = function(e) {
        function t() {
            var e, n, c, i;
            return function(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }(this, t),
            n = this,
            c = o(c = t),
            (e = r(n, a() ? Reflect.construct(c, i || [], o(n).constructor) : c.apply(n, i))).label = e.querySelector("label"),
            e.checkbox = e.querySelector('input[type="checkbox"]'),
            e.content = e.querySelector(".accordion__contents"),
            e.contentInner = e.querySelector(".accordion__content-inner"),
            e.parentAccordion = e.parentNode.closest("accordion-item"),
            e.expandOn = "click",
            e.label.addEventListener(e.expandOn, e.onItemClick.bind(e)),
            "mouseenter" === e.expandOn && e.addEventListener("mouseleave", e.closeItem.bind(e)),
            document.addEventListener("collapsibleContentInView", (function(t) {
                t.detail.item === e ? e.onItemClick(new Event("click")) : e.closeItem()
            }
            )),
            e
        }
        return function(e, t) {
            if ("function" != typeof t && null !== t)
                throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }),
            Object.defineProperty(e, "prototype", {
                writable: !1
            }),
            t && c(e, t)
        }(t, e),
        i = t,
        (u = [{
            key: "onItemClick",
            value: function(e) {
                if (e.preventDefault(),
                this.checkbox.checked)
                    this.checkbox.checked = !1,
                    this.classList.remove("accordion--expanded");
                else {
                    this.classList.add("accordion--expanded");
                    var t = this.contentInner.clientHeight + "px";
                    this.content.style.setProperty("--max-height", t),
                    this.checkbox.checked = !0,
                    this.parentAccordion && this.parentAccordion.updateParentHeight(t)
                }
            }
        }, {
            key: "closeItem",
            value: function() {
                this.checkbox.checked = !1,
                this.classList.remove("accordion--expanded")
            }
        }, {
            key: "updateParentHeight",
            value: function(e) {
                var t = this.contentInner.clientHeight + e + "px";
                this.content.style.setProperty("--max-height", t),
                this.parentAccordion && this.parentAccordion.updateParentHeight(t)
            }
        }]) && n(i.prototype, u),
        l && n(i, l),
        Object.defineProperty(i, "prototype", {
            writable: !1
        }),
        i;
        var i, u, l
    }(u(HTMLElement));
    try {
        customElements.define("accordion-item", l)
    } catch (e) {}
}
)();
 